import { useQuery } from '@tanstack/react-query';
import { getIntegrationsSettings } from './getIntegrationsSettings';
import { COMPANY_API_SETTINGS_MOCKED } from '@/env';
import { mockIntgrationsSettings } from './mock';
import { IntegrationsConfigurationModel } from './types';
import { QUERY_KEY_SETTINGS_INTEGRATION, SETTINGS_QUERY_NO_CACHE } from '@/lib/api/constants'

type Props = {
  companyId: string
}

export function useQueryIntegrationsSettings(props: Props) {
  const { companyId } = props
  return useQuery<IntegrationsConfigurationModel>({
    queryKey: [QUERY_KEY_SETTINGS_INTEGRATION, companyId],
    queryFn: async () => {
      if (COMPANY_API_SETTINGS_MOCKED) {
        return mockIntgrationsSettings
      }
      // @TODO remove companyId from queryKey and endpoint when backend is fixed
      const { data } = await getIntegrationsSettings(props);
      return data;
    },
    ...SETTINGS_QUERY_NO_CACHE,
  });
}
